class PageCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.isUpdating = false;
    this.debounceTimeout = null;
    document.getElementById("global-loading-cursor")?.remove();

    this.inputQuantity();
    this.inputButtons();
    this.removeProduct();
    this.moveFreeShippingBar();
  }

  inputQuantity() {
    const inputs = this.querySelectorAll("input[data-cart-quantity]");
    inputs.forEach((input) => {
      if (this.isUpdating) {
        input.disabled = true;
        return;
      }

      input.addEventListener("blur", () => {
        if (this.isUpdating) return;
        this.handleQuantityUpdate(input);
      });

      //faz com que o enter apenas saia do blur
      input.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          input.blur();
        }
      });
    });
  }

  handleQuantityUpdate(input) {
    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = setTimeout(() => {
      const inventoryQuantity = parseInt(
        input.getAttribute("data-cart-inventory-quantity"),
      );
      const currentQuantity = parseInt(input.value);
      const cartItem = input.closest("[data-cart-item]");
      const itemId = cartItem.dataset.itemId;

      if (currentQuantity > inventoryQuantity) {
        const messageQuantity = cartItem.querySelector(
          "[data-cart-quantity-message]",
        );
        let messageValue = messageQuantity.getAttribute(
          "data-cart-quantity-message",
        );
        messageValue = messageValue.replace(
          "-quantidade-disponivel-",
          inventoryQuantity,
        );
        if (messageQuantity) {
          messageQuantity.innerHTML = messageValue;
          messageQuantity.style.display = "block";
        }

        input.value = inventoryQuantity;
      } else {
        const messageQuantity = cartItem.querySelector(
          "[data-cart-quantity-message]",
        );
        if (messageQuantity) {
          messageQuantity.style.display = "none";
        }
      }
      const newQuantity = input.value;
      7;
      this.updateCart(cartItem, newQuantity, itemId);
    }, 500);
  }

  inputButtons() {
    if (this.isUpdating) return;
    this.querySelectorAll("[data-quantity-wrapper]").forEach((wrapper) => {
      const input = wrapper.querySelector("[data-quantity-input]");
      const btnMinus = wrapper.querySelector("[data-decrease]");
      const btnPlus = wrapper.querySelector("[data-increase]");
      

      btnMinus.addEventListener("click", () => {
        if (this.isUpdating) return;
        let current = parseInt(input.value, 10) || 0;

        if (current > 1) {
          input.value = current - 1;
          this.handleQuantityUpdate(input);
        } else {
          const removeButtons = this.querySelectorAll(
            "[data-cart-remove-button]",
          );
          removeButtons.forEach((button) => {
            button.dispatchEvent(new Event("click", { bubbles: true }));
          });
        }
      });

      btnPlus.addEventListener("click", () => {
        if (this.isUpdating) return;
        let current = parseInt(input.value, 10) || 0;
        
        input.value = current + 1;
        this.handleQuantityUpdate(input);
      });
    });
  }

  async removeProduct() {
    const removeButtons = this.querySelectorAll("[data-cart-remove-button]");

    removeButtons.forEach((button) => {
      button.addEventListener("click", async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const itemContainer = button.closest("[data-cart-item");
        const itemId = itemContainer.dataset.itemId;
        if (itemId) {
          this.removeCartItem(itemId);
        }
      });
    });
  }

  async removeCartItem(itemId) {
    const formData = new FormData();
    formData.append(`updates[${itemId}]`, 0);
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Erro ao remover item do carrinho");

      this.reloadSection();
    } catch (error) {
      console.error("Erro ao remover item do carrinho:", error);
    }
  }

  async updateCart(cartItem, newQuantity, itemId) {
    this.isUpdating = true;
    this.isLoading(cartItem);

    //Atualizar a requisição cart
    const formData = new URLSearchParams();
    formData.append(`updates[${itemId}]`, newQuantity);

    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      });

      if (!response.ok) throw new Error("Erro ao atualizar item no carrinho");

      const updatedCart = await response.json();
    } catch (error) {
      console.error("Erro na atualização:", error);
    }

    this.reloadSection();
  }

  isLoading(cartItem) {
    //cursor wait
    const loadingStyle = document.createElement("style");
    loadingStyle.id = "global-loading-cursor";
    loadingStyle.innerHTML = `* { cursor: wait !important; }`;
    document.head.appendChild(loadingStyle);

    const loadingBar = cartItem.querySelectorAll("[loadingbar]");
    loadingBar.forEach((item) => {
      item.style.display = "block";
    });

    //efeito loading
    const price = cartItem.querySelector(".price");
    const subTotal = this.querySelector(".valueSubTotal");
    const total = this.querySelector(".valueTotal");
    const discount = this.querySelector(".valueDiscount");
    const textFreeShipping = this.querySelectorAll(".textFreeShipping");
    textFreeShipping.forEach((item) => {
      item.classList.add("loadingAttributes");
    });

    [price, subTotal, total, discount].forEach((el) => {
      el?.classList.add("loadingAttributes");
    });
  }

  moveFreeShippingBar() {
    //barra de frete dinâmica
    const bars = this.querySelectorAll("[freeShippingBar]");
    const trucks = this.querySelectorAll("[freeShippingTruckBar]");
    const initialBars = this.querySelectorAll("[initialBar]");

    let percentageBar = "";
    initialBars.forEach((initialBar) => {
      const value = initialBar.getAttribute("initialBar");
      percentageBar = value;
    });

    if (bars.length && trucks.length) {
      setTimeout(() => {
        bars.forEach((bar) => {
          bar.style.width = `${percentageBar}%`;
        });

        trucks.forEach((truck) => {
          truck.style.left = `calc(${percentageBar}% - 22px)`;
        });
      }, 100);
    }
  }

  async reloadSection() {
    //atualizar o html
    const response = await fetch("/cart?section_id=template-cart");
    if (!response.ok) throw new Error("Erro ao buscar carrinho");
    const text = await response.text();
    const newDocument = new DOMParser().parseFromString(text, "text/html");
    const newPageCart = newDocument.querySelector("page-cart");

    //busca freeShippingBar antiga
    const oldBar = this.querySelector("[freeShippingBar]");
    const oldTruck = this.querySelector("[freeShippingTruckBar]");
    const oldPercentage = oldBar?.style.width || "0%";
    const oldTruckLeft = oldTruck?.style.left || "0px";
    const newInitials = this.querySelectorAll("[initialBar]");

    //busca mensagem de quantidade a mais antiga
    const oldMessages = this.querySelectorAll("[data-cart-quantity-message]");

    if (newPageCart) {
      // atualiza a página cart
      this.innerHTML = newPageCart.innerHTML;

      //atualiza dinâmicamente freeShippingBar começando da porcentagem atiga
      const newBars = this.querySelectorAll("[freeShippingBar]");
      const newTrucks = this.querySelectorAll("[freeShippingTruckBar]");
      newInitials.forEach((newInitial) => {
        newInitial.setAttribute("initialBar", oldPercentage.replace("%", ""));
      });
      newBars.forEach((newBar) => {
        newBar.style.width = oldPercentage;
      });
      newTrucks.forEach((newTruck) => {
        newTruck.style.left = oldTruckLeft;
      });

      //caso tenha o aviso de quantidade ele mantém.
      const newMessages = this.querySelectorAll("[data-cart-quantity-message]");
      oldMessages.forEach((oldEl, i) => {
        const newEl = newMessages[i];
        if (!newEl) return;

        newEl.innerHTML = oldEl.innerHTML;

        //descobre e aplica o display
        const inlineDisplay = oldEl.style.display;
        const computedDisplay = window.getComputedStyle(oldEl).display;
        const finalDisplay = inlineDisplay || computedDisplay;
        newEl.style.display = finalDisplay;

        // prepara para a animação de opacidade
        newEl.style.opacity = "1";
        newEl.style.transition = "opacity 0.5s ease";

        // se está visível, agenda o fade após 3 segundos
        if (finalDisplay !== "none") {
          setTimeout(() => {
            // dispara a animação
            newEl.style.opacity = "0";

            // quando a transição terminar, remove o display inline
            newEl.addEventListener("transitionend", function handler() {
              newEl.style.display = ""; // volta a obedecer o CSS original
              newEl.style.opacity = ""; // limpa para o próximo uso
              newEl.style.transition = ""; // opcional: limpa a transição
              newEl.removeEventListener("transitionend", handler);
            });
          }, 3000);
        }
      });

      //chama o início novamente
      this.init();

      this.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    }

    //atualizar a quantidade do ícone da sacola
    const bagResponse = await fetch("/cart?section_id=bag-drawer");
    if (!bagResponse.ok) throw new Error("Erro ao buscar ícone sacola");

    const bagText = await bagResponse.text();
    const newBagDocument = new DOMParser().parseFromString(
      bagText,
      "text/html",
    );
    const oldBagDrawer = document.querySelectorAll(".quantity_badges");
    const newBagDrawer = newBagDocument.querySelectorAll(".quantity_badges");
    const newValue = newBagDrawer[0]?.textContent;

    if (newValue !== undefined) {
      oldBagDrawer.forEach((item) => {
        item.textContent = newValue;
      });
    }
  }
}

customElements.define("page-cart", PageCart);
